import { forwardRef } from 'react';
import { CheckboxProps } from './types';
import { useFormContext } from 'react-hook-form';
import CheckboxHookForm from './CheckboxHookForm';
import CheckboxBase from './CheckboxBase';

const Checkbox = forwardRef<HTMLDivElement, CheckboxProps>((props, ref) => {
  const formContext = useFormContext();

  if (formContext)
    return <CheckboxHookForm ref={ref} formContext={formContext} {...props} />;

  return <CheckboxBase ref={ref} {...props} />;
});

export default Checkbox;
